import { render, staticRenderFns } from "./JToolDemo.vue?vue&type=template&id=1ca9c913"
import script from "./JToolDemo.vue?vue&type=script&lang=js"
export * from "./JToolDemo.vue?vue&type=script&lang=js"
import style0 from "./JToolDemo.vue?vue&type=style&index=0&id=1ca9c913&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports